<template>
<div />
</template>

<script>
  /* eslint-disable */
  export default {
    name: 'DashboardCoreFooter',

    data: () => ({
      links: [
      ]
    })
  }
</script>

<style lang="sass">
  #dashboard-core-footer
    a
      color: #3c4858
      font-size: .825rem
      font-weight: 500
      text-decoration: none
      text-transform: uppercase
</style>
